/**
 * Lo que la institución puede configurar.
 *
 * El servidor devuelve el CATÁLOGO junto al estado, no solo el estado: los
 * nombres y las descripciones vienen de ahí. Repetirlos aquí crearía una
 * segunda lista que acabaría discrepando, que es un problema que este
 * proyecto ya ha pagado.
 */

import { get, post } from '@/lib/api'

export type Perfil =
  | 'ADMIN'
  | 'RADIOLOGIST'
  | 'DOCTOR'
  | 'TECHNICIAN'
  | 'TRANSCRIPTOR'
  | 'PATIENT'

export interface FuncionalidadConfigurable {
  codigo: string
  nombre: string
  descripcion: string
  habilitada: boolean
  perfiles: Perfil[]
  /** Si la institución puede repartirla entre perfiles. */
  delegable: boolean
  loDecide: 'institucion'
  porDefecto: { habilitada: boolean; perfiles: Perfil[] }
}

export interface ModuloConfigurable {
  codigo: string
  nombre: string
  descripcion: string
  habilitado: boolean
  /**
   * Si el PLAN lo incluye. Distinto de estar encendido: lo que no incluye el
   * plan no lo puede encender ni el proveedor, hay que cambiar de plan.
   */
  enElPlan: boolean
  /** Los módulos los activa quien vendió, no la institución. */
  loDecide: 'proveedor'
  funcionalidades: FuncionalidadConfigurable[]
}

export interface Configuracion {
  institutionId: string
  modulos: ModuloConfigurable[]
  perfiles: Perfil[]
}

export interface Decision {
  codigo: string
  habilitada: boolean
  perfiles?: Perfil[]
}

export async function getConfiguracion(institutionId?: string): Promise<Configuracion> {
  const query = institutionId ? `?institutionId=${institutionId}` : ''
  return get<Configuracion>(`/configuracion${query}`)
}

export async function guardarConfiguracion(
  decisiones: Decision[],
  institutionId?: string
): Promise<{ guardadas: number }> {
  const query = institutionId ? `?institutionId=${institutionId}` : ''
  return post<{ guardadas: number }>(`/configuracion${query}`, { decisiones })
}
